// src/lib/models/contact.ts
// Mirrors go.nexilink/models/contact.go

export type ContactStatus = 'new' | 'contacted' | 'closed';
export type ContactType = 'demo' | 'pilot';

export interface Contact {
    id: string;
    name: string;
    email: string;
    municipality: string;
    message?: string;
    type: ContactType;
    status: ContactStatus;
    created_at: string;
    created_by: string;
    updated_at: string;
    updated_by: string;
}

export const ContactStatusLabels: Record<ContactStatus, string> = {
    new: 'Ny',
    contacted: 'Kontaktad',
    closed: 'Avslutad',
};

export const ContactStatusColors: Record<ContactStatus, string> = {
    new: 'blue',
    contacted: 'yellow',
    closed: 'gray',
};

export const ContactTypeLabels: Record<ContactType, string> = {
    demo: 'Boka demo',
    pilot: 'Bli pilotkommun',
};
